export default __webpack_public_path__ + "static/media/quotes.e1394d9b.svg";